var _circle, _rect, _circle2, _rect2, _path, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 486,
    height: 486,
    viewBox: "0 0 486 486",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 53,
    r: 32.5,
    fill: "#0266FF",
    stroke: "#0266FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 122.5,
    y: 70.5,
    width: 19,
    height: 58,
    fill: "#0266FF",
    stroke: "#0266FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 354,
    cy: 53,
    r: 32.5,
    fill: "#0266FF",
    stroke: "#0266FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 344.5,
    y: 70.5,
    width: 19,
    height: 58,
    fill: "#0266FF",
    stroke: "#0266FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141 135H345C416.797 135 475 193.203 475 265V280.75C475 343.849 423.849 395 360.75 395V405.988L360.538 395.002L208.057 397.939C203.511 398.027 199.135 399.66 195.647 402.563L195.312 402.849L152.156 440.404C151.894 440.632 151.738 440.658 151.66 440.668C151.53 440.684 151.322 440.667 151.086 440.56C150.849 440.452 150.7 440.306 150.627 440.197C150.583 440.132 150.5 439.997 150.5 439.649V408C150.5 400.82 144.68 395 137.5 395C67.636 395 11 338.364 11 268.5V265C11 193.203 69.203 135 141 135Z",
    stroke: "#0266FF",
    strokeWidth: 22
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.5,
    cy: 268.5,
    r: 45,
    fill: "#0266FF",
    stroke: "#0266FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 337.5,
    cy: 268.5,
    r: 45,
    fill: "#0266FF",
    stroke: "#0266FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuraIcon);
export default __webpack_public_path__ + "static/media/aura-icon.87d1af4e1c14efcce623de50404f1299.svg";
export { ForwardRef as ReactComponent };